import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'classroom_enrollments',
  label: 'Matrículas da turma',
  actions: ['list', 'create', 'edit', 'delete'],
  onlyPermission: true,
  parentName: 'classroom_management'
};

export default generateResources(resource);
